import React, {
  useEffect,
  useState,
} from 'react';
import moment from 'moment';
import {
  Card, Switch, TextField,
  TextFieldProps, CardContent,
} from '@material-ui/core';

import {
  DayOptionProps,
  DayOptions,
  DayDate,
  NotificationBatch,
  WeekDays,
  NotificationBatchesProps,
} from './types';

import styles from './styles.module.scss';

const NotificationBatches: React.FC<NotificationBatchesProps> = (props: NotificationBatchesProps) => {
  const {
    batchesChanged,
    error: emptySelectionError,
  } = props;
  let batches: NotificationBatch [] = [];
  // const [, setBatches] = useState<NotificationBatch []>([]);
  const DayOption = (dayOptionProps: DayOptionProps) => {
    const {
      title,
      handleChange,
    } = dayOptionProps;

    const [startTime, setstartTime] = useState('12:00');
    const [endTime, setendTime] = useState('20:00');
    const [timesAtDay, setTimesAtDay] = useState(4);
    const [selected, setSelected] = useState<boolean>(false);
    const [error, setError] = useState({
      start_date: '',
      end_date: '',
      times_at_day: '',
    });

    useEffect(() => {
      setError((err) => ({
        ...err,
        end_date: '',
        start_date: '',
      }));
      if (startTime > endTime) {
        setError((err) => ({
          ...err,
          start_date: 'Cannot be after end time ',
        }));
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startTime]);

    useEffect(() => {
      setError((err) => ({
        ...err,
        end_date: '',
        start_date: '',
      }));
      if (startTime > endTime) {
        setError((err) => ({
          ...err,
          end_date: 'Cannot be before start time',
        }));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [endTime]);

    useEffect(() => {
      setError((err) => ({
        ...err,
        times_at_day: '',
      }));
      if (timesAtDay > 8 || timesAtDay < 1) {
        setError((err) => ({
          ...err,
          times_at_day: 'Cannot be more than 8 or less than 1',
        }));
      }
    }, [timesAtDay]);

    useEffect(() => {
      const isValidRow = () => (Object.values(error).every((e) => e === ''));
      handleChange({
        selected,
        startTime,
        endTime,
        timesAtDay,
        valid: isValidRow(),
      });
    }, [startTime, endTime, timesAtDay, selected, handleChange, error]);

    const ConditionalTextField = (textFieldProps: (TextFieldProps & {isSelected: boolean, errorMessage: string})) => {
      const {
        isSelected,
        errorMessage,
        error: isError,
        ...rest
      } = textFieldProps;
      if (!isSelected) return null;
      return (
        <div className={styles.inputWidth}>
          <TextField {...rest} />
          {isError && <h6 className={styles.error}>{errorMessage}</h6>}
        </div>
      );
    };

    return (
      <div className={styles.dayOption}>
        <h4>{title}</h4>
        <Switch
          className={styles.switch}
          color="secondary"
          checked={selected}
          onChange={() => setSelected(!selected)}
        />
        <ConditionalTextField
          // autoFocus
          isSelected={selected}
          label="Start time"
          onChange={(e) => setstartTime(e.target.value)}
          value={startTime}
          type="time"
          error={!!error?.start_date}
          errorMessage={error?.start_date}
        />
        <ConditionalTextField
          // autoFocus
          isSelected={selected}
          label="End time"
          onChange={(e) => setendTime(e.target.value)}
          value={endTime}
          error={!!error?.end_date}
          errorMessage={error?.end_date}
          type="time"
        />
        <ConditionalTextField
          autoFocus
          isSelected={selected}
          label="Number of notifications"
          placeholder="Number of notifications"
          onChange={(e) => setTimesAtDay(+e.target.value)}
          value={timesAtDay}
          type="number"
          error={!!error?.times_at_day}
          errorMessage={error?.times_at_day}
        />
      </div>
    );
  };
  const handleDayChange = (dayDate: DayDate, dayOptions: DayOptions) => {
    const {
      date,
    } = dayDate;
    const {
      endTime,
      selected,
      startTime,
      timesAtDay: times,
      valid,
    } = dayOptions;
    const batch: NotificationBatch = {
      endTime,
      startTime,
      sendDate: date.format(),
      times,
      valid,
    };
    if (
      selected && !batches.find((b) => b.sendDate === date.format())) {
      batches.push(batch);
    } else {
      batches = batches.filter((b) => b.sendDate !== date.format());
    }
    if (batches.length) {
      batchesChanged(batches);
    }
  };

  const currentDay = new Date().getDay() + 1;
  const days: DayDate [] = [];
  for (let i = 1; i <= 7; i += 1) {
    const currentDate = moment(new Date());
    let dayConstant = 7;
    if (i > currentDay) {
      dayConstant = 0;
    }
    const dateIndex = dayConstant - (currentDay - i) - 1;
    const d = {
      key: Object.keys(WeekDays)[i - 1],
      date: currentDate.add(dateIndex, 'days'),
    };
    days[dateIndex] = d;
  }
  return (
    <Card className={emptySelectionError ? styles.batchesError : ''}>
      <CardContent>
        {days
          .map((d) => (
            <DayOption
              key={d.key}
              title={d.key}
              handleChange={(dayOptions: DayOptions) => handleDayChange(d, dayOptions)}
            />
          ))}
      </CardContent>
    </Card>
  );
};

export default NotificationBatches;
